import { render, staticRenderFns } from "./DefaultNavigationBar.vue?vue&type=template&id=066688d0&scoped=true"
import script from "./DefaultNavigationBar.vue?vue&type=script&lang=ts"
export * from "./DefaultNavigationBar.vue?vue&type=script&lang=ts"
import style0 from "./DefaultNavigationBar.vue?vue&type=style&index=0&id=066688d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066688d0",
  null
  
)

export default component.exports